import React from 'react';
import { Outlet } from 'react-router';
import { IntlProvider } from 'react-intl';
import ExternalMain from '../containers/ExternalMain';
import ExternalNavBar from './ExternalNavBar';
import { LicenseManager } from 'ag-grid-enterprise';
import { withRouter } from '../common/withRouter';

//Set AG Grid license key
LicenseManager.setLicenseKey(process.env.AG_GRID_UI_LICENSE);

/**
 * The ExternalApp class.  This is the parent component for all routes.
 * @extends {React.Component}
 */
class ExternalApp extends React.Component {
  /**
   * Creates a new ExternalApp
   * @constructor
   * @param {Object} props The component properties
   * @param {Object} context The component context
   */
  constructor(props, context) {
    super(props, context);
  }

  render() {
    return (
      <IntlProvider locale="en">
        <div className="container-fluid no-padding">
          <ExternalNavBar />
          <ExternalMain isPermExternalApp={false}>
            <Outlet />
          </ExternalMain>
        </div>
      </IntlProvider>
    );
  }
}

export default withRouter(ExternalApp);
